import { useTranslation } from "react-i18next"

import Table, { Body, Header, HeaderCell } from "@/components/Table/Table"
import type { TaskSubmission } from "@/types/taskSubmissionTypes"

import FeedbacksItem from "./FeedbacksItem"
export default function FeedbacksShow({
  feedbacks,
}: {
  feedbacks: Array<TaskSubmission>
}) {
  const { t } = useTranslation()
  return (
    <div>
      <Table>
        <Header>
          <HeaderCell>{t("feedbacksPage.table.no")}</HeaderCell>
          <HeaderCell>{t("feedbacksPage.table.lecture")}</HeaderCell>
          <HeaderCell>{t("feedbacksPage.table.feedback")}</HeaderCell>
        </Header>
        <Body>
          {feedbacks?.map((ele, index) => {
            return <FeedbacksItem key={ele.id} ele={ele} index={index} />
          })}
        </Body>
      </Table>
    </div>
  )
}
